module.exports = __webpack_public_path__ + "img/logo-icon-app.afef95fa.png";